import {getCompetentAuthorities} from "@/services/competentAuthority";


const state = {
  competentAuthorities: [],

}

const mutations = {
  setCompetentAuthorities(state, payload) {
    state.competentAuthorities = payload;
  },
}

const getters = {
  competentAuthorities(state){
    return state.competentAuthorities
  },
  activeCompetentAuthorities(state) {
    return state.competentAuthorities && state.competentAuthorities.length > 0 ? state.competentAuthorities.filter((el) => el.active === 1) : [];
  }
}

const actions = {
  actionSetCompetentAuthorities({commit}) {
    return new Promise((resolve, reject) => {
      getCompetentAuthorities().then((response) => {
        commit('setCompetentAuthorities', response.data)
        resolve(response.data);
      }, (error) => {
        reject(error);
      });
    })
  },
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}
